import type { AuthState } from "./types";

export interface WorkspaceNavigationAccess {
  auth?: AuthState;
  canUseOrganizerDashboard: boolean;
  canUseScanner: boolean;
  isOwner: boolean;
}

export interface WorkspaceNavigationItem {
  id: "dashboard" | "event-manager" | "scanner" | "ticket-list" | "owner";
  label: "Dashboard" | "Event Manager" | "Scanner" | "Ticket List" | "Owner";
  path: string;
}

export function buildWorkspaceNavigationItems(access: WorkspaceNavigationAccess): WorkspaceNavigationItem[] {
  if (!access.auth) return [];

  const items: WorkspaceNavigationItem[] = [];
  if (access.canUseOrganizerDashboard) {
    items.push({ id: "dashboard", label: "Dashboard", path: "/app" });
    items.push({ id: "event-manager", label: "Event Manager", path: "/app/events" });
  }
  if (access.canUseScanner) {
    items.push({ id: "scanner", label: "Scanner", path: "/scanner" });
    items.push({ id: "ticket-list", label: "Ticket List", path: "/scanner/tickets" });
  }
  if (access.isOwner) items.push({ id: "owner", label: "Owner", path: "/owner" });
  return items;
}

export function getWorkspaceNavigationLabel(path: string): WorkspaceNavigationItem["label"] {
  if (path === "/scanner/tickets") return "Ticket List";
  if (path === "/scanner") return "Scanner";
  if (path === "/owner" || path.startsWith("/owner/")) return "Owner";
  if (path === "/app/events" || path.startsWith("/app/events/")) return "Event Manager";
  return "Dashboard";
}
